export default __webpack_public_path__ + "static/media/limitedQty.e6bc9057.svg";